/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { useEffect, useState } from "react";
import { Users, Content, Reports } from "./";
import { Transition, Tab, TabProps } from "semantic-ui-react";
import Organizations from "./Organizations";
import Builds from "./Builds";
import "./datePicker.css";
import { setUrlPath } from "../../Authenticator/utils";

interface ManageProps {
  sessionInfo: any;
}

const Manage: React.FC<ManageProps> = ({ sessionInfo }) => {
  const [activeIndex, setActiveIndex] = useState<any>(0);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const showSelectedUser = (userEmail: string) => {
    setActiveIndex(0);
    setUrlPath("/Manage/Users");
    setSelectedUser(userEmail);
  };

  const [selectedOrg, setSelectedOrg] = useState<string | null>(null);
  const showSelectedOrg = (orgName: string) => {
    setActiveIndex(1);
    setUrlPath("/Manage/Organizations");
    setSelectedOrg(orgName);
  };

  if (!sessionInfo.role.startsWith("SUPPORT")) {
    return null;
  }
  const ro = sessionInfo.role.endsWith("_RO");

  useEffect(() => {
    // Set the manage tab according to the url path on startup
    const managePath = window.location.pathname.split("/").pop();
    const managePathIndex = panes.findIndex(
      (pane) => pane.menuItem === managePath
    );

    if (managePathIndex > 0 && managePathIndex !== activeIndex) {
      setActiveIndex(managePathIndex);
    }
  }, []);

  const handleTabChange = (
    _: React.MouseEvent<HTMLDivElement>,
    data: TabProps
  ) => {
    const menuItem = data.panes?.[data.activeIndex as number].menuItem;
    setUrlPath(`/Manage/${menuItem}`);
    setActiveIndex(data.activeIndex);
  };

  const panes = [
    {
      menuItem: "Users",
      pane: (
        <Tab.Pane key="Users">
          <Users
            ro={ro}
            setSelectedUser={setSelectedUser}
            selectedUser={selectedUser}
            showSelectedOrg={showSelectedOrg}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Organizations",
      pane: (
        <Tab.Pane key="Organizations">
          <Organizations
            ro={ro}
            showSelectedUser={showSelectedUser}
            setSelectedOrg={setSelectedOrg}
            selectedOrg={selectedOrg}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Report",
      pane: (
        <Tab.Pane key="Report">
          <Reports ro={ro} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Builds",
      pane: (
        <Tab.Pane key="Builds">
          <Builds />
        </Tab.Pane>
      ),
    },
  ];

  if (!ro) {
    panes.push({
      menuItem: "Content",
      pane: (
        <Tab.Pane key="Content">
          <Content />
        </Tab.Pane>
      ),
    });
  }

  return (
    <React.Fragment>
      <Transition transitionOnMount animation="fade in" duration="250">
        <Tab
          activeIndex={activeIndex}
          onTabChange={handleTabChange}
          panes={panes}
          renderActiveOnly={false}
          style={{ marginBottom: "2rem" }}
        />
      </Transition>
    </React.Fragment>
  );
};

export default Manage;
